<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="header">Processando Solicitação</h2>
        <v-alert
          type="warning"
          :value="true"
          icon="warning"
          v-if="processInExecution"
        >
          Permaneça na tela enquanto realizamos a análise de regras para
          aprovação automática...
        </v-alert>
        <h4 class="sub_header" v-if="!processInExecution">
          Processo executado.
        </h4>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-for="item in processSteps" v-bind:key="item.step">
        <div v-if="item.display">
          <v-progress-circular
            :size="23"
            indeterminate
            color="#282498"
            v-if="item.status == 'pending'"
          ></v-progress-circular>
          <v-icon
            v-if="item.status != 'pending'"
            :class="checkIconClass(item)"
            v-html="checkIconType(item)"
          ></v-icon>
          <span
            class="text_default"
            v-html="item.text"
            :class="checkTextClass(item)"
          ></span>
        </div>
      </v-flex>
      <v-flex xs12 v-if="message">
        <v-card :class="checkCardClass()">
          <v-layout col xs12>
            <v-icon
              :class="checkCardIconClass()"
              v-html="checkCarIconType()"
            ></v-icon>
            <div v-html="message"></div>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="!processInExecution && checkActualStepStatus()">
        <v-layout row wrap pl-0 mr-3>
          <v-flex :class="!mostraBotaoAvancar ? 'xs6  offset-xs6' : 'xs6'">
            <v-btn class="button jns-button blue-button" @click="emmit('home')">
              Nova Apólice
            </v-btn>
          </v-flex>

          <v-flex xs6 v-if="mostraBotaoAvancar" style="margin-top: 9px;">
            <v-btn
              class="button jns-button yellow-button"
              @click="emmit('timeline')"
            >
              Avançar
              <v-icon>arrow_right_alt</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex
        xs12
        offset-xs6
        pt-0
        v-if="!processInExecution && !checkActualStepStatus()"
      >
        <v-btn
          class="button jns-button yellow-button"
          @click="emmit('nextStep')"
        >
          Seguir para emissão
          <v-icon>arrow_right_alt</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12 offset-xs6 pt-0 v-if="processInExecution">
        <v-btn class="button jns-button yellow-button" disabled
          >Executando...</v-btn
        >
      </v-flex>
    </v-layout>
  </div>
</template>

<script lang="js">
export default {
  name: "ProcessoSolicitacaoProposta",
  data() {
    return {
      analiseCredito: false,
    };
  },
  props: [
    "processSteps",
    "processInExecution",
    "message",
    "processSuccess",
    "mostraBotaoAvancar",
  ],
  methods: {
    // Verificar qual a classe ícone de acordo com status
    checkIconClass(step) {
      if (step.status == "pending") {
        return "";
      }
      if (step.status == "success") {
        return "icon_success";
      }
      if (step.status == "error") {
        this.analiseCredito = step.step == 2;
        return "icon_error";
      }
    }, // ./ checkIconClass

    // Verificar o tipo de icone de acordo com status
    checkIconType(step) {
      if (step.status == "pending") {
        return "check_circle";
      }
      if (step.status == "success") {
        return "check_circle";
      }
      if (step.status == "error") {
        return "cancel";
      }
    }, // ./ checkIconType

    // Verificar qual a classe do texto de acordo com status
    checkTextClass(step) {
      if (step.status == "pending") {
        return "text_default";
      }
      if (step.status == "success") {
        return "text_success";
      }
      if (step.status == "error") {
        return "text_error";
      }
    }, // ./ checkTextClass

    // Verificar se existe algum passo com erro
    checkActualStepStatus() {
      let withError = this.processSteps.find((step) => step.status == "error");
      return withError != null;
    }, // ./ checkActualStepStatus

    checkCardClass() {
      if (this.processSuccess) {
        return "card_message success";
      } else return "card_message";
    }, // ./ checkCardClass

    checkCardIconClass() {
      if (this.processSuccess) {
        return "icon_card success";
      } else return "icon_card padding-bottom-icon";
    }, // ./ checkCardIcon

    checkCarIconType() {
      if (this.processSuccess) {
        return "check";
      } else return "close";
    }, // ./ checkCarIconType

    emmit(sector) {
      this.$emit("goto", sector);
    }, // ./ emmit
  },
};
</script>

<style lang="scss" scoped>
$colorSuccess: #6bd43e;
$colorError: #e2005d;

.header {
  color: #282498;
}

.sub_header {
  color: darkgray;
}

.text_default {
  padding-left: 20px;
}

.text_success {
  padding-left: 20px;
}

.text_error {
  padding-left: 20px;
  color: $colorError;
}

.icon_success {
  color: $colorSuccess;
}

.icon_error {
  color: $colorError;
}

.card_message {
  border-radius: 7px;
  background-color: $colorError;
  padding: 20px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 900;

  .success {
    background-color: $colorSuccess;
  }

  .icon_card {
    padding: 0px;
    color: #ffffff;
    padding-top: 0px;
    padding-bottom: 20px;
    padding-right: 10px;
    font-weight: bold;
  }

  .padding-bottom-icon {
    padding-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProcessoSolicitacaoProposta.vue